import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

export type Product = DeepReadonly<{
  id: string
  name: string
  parentCategoryId: string | null
  measure: string | null
  description: string
  price: number
  vatRate: number | null
  color: string
  tagIds: string[]
  hasOptions: boolean
  isActive: boolean
  hasVariablePrice: boolean
  categoryPath: string
}>

export const listProducts = async (): Promise<
  Product[]
> => {
  const response = await api.get<Product[]>(
    "/products/products/"
  )
  return response.body
}

export type ProductFilters = Partial<{
  search: string
  parentCategoryId: string
}>

export const useProducts = (
  filters: MaybeRef<ProductFilters> = {}
) => {
  const { data: allProducts, ...useQueryReturns } =
    useQuery({
      queryKey: [BASE_PRODUCTS_QUERY_KEY],
      queryFn: () => listProducts(),
      staleTime: 60 * 60 * 1000,
    })

  const data = computed(() => {
    if (!allProducts.value) return []
    const filtered =
      unref(filters).parentCategoryId === undefined
        ? allProducts.value
        : allProducts.value?.filter(
            (product) =>
              product.parentCategoryId ===
              unref(filters).parentCategoryId
          )
    const search = unref(filters).search
    const searched = search
      ? searchBy(filtered, ["name", "categoryPath"], search)
      : filtered
    return [...searched].sort((product1, product2) =>
      product1.categoryPath.localeCompare(
        product2.categoryPath
      )
    )
  })

  return {
    allProducts: allProducts,
    data: data,
    ...useQueryReturns,
  }
}
